<template>
<div>
  <!-- BOC:[table] -->
  <BreadBrowseTable
    role="Moderator"
    :model="model"
    :url="`${$api.servers.sso}/api/v1/en/moderator/account/${grandParent.id}/classroom/${parent.id}/student`"
    :isSearchable="true"
    :parent="parent"
    :modelParent="modelParent"
    :grandParent="grandParent"
    :modelGrandParent="modelGrandParent"
  ></BreadBrowseTable>
  <!-- EOC -->
</div>
</template>

<script>
  //BOC:[model]
  import modelGrandParent from '@/models/items/account'
  import modelParent from '@/models/items/classroom'
  import model from '@/models/items/student'
  //EOC
  //BOC:[table]
  import BreadBrowseTable from '@/components/Bread/BreadBrowseTable'
  //EOC
  import { mapState } from 'vuex'
  export default {
    components:{
      //BOC:[table]
      BreadBrowseTable,
      //EOC
    },
    computed: mapState({
      school: state => state.school.data,
    }),
    props:[
      'role',
      'parent',
      'grandParent',
    ],
    data:()=>({
      //BOC:[model]
      modelParent:modelParent,
      modelGrandParent: modelGrandParent,
      model: model,
      //EOC
    }),
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      //
    }
  }
</script>